module.exports = __webpack_public_path__ + "product/product-step-plain-a02f89dcaefdeb608df0979423e325a8.png";